import z from "zod";

// TODO: move to types package
const errorSeverityValues = ["LOW", "MEDIUM", "HIGH", "URGENT"] as const;
const errorSeveritySchema = z.enum(errorSeverityValues);
export const ErrorSeverity = errorSeveritySchema.enum;
export type ErrorSeverity = z.infer<typeof errorSeveritySchema>;

export const ErrorSeverityToPriority = {
  LOW: 80,
  MEDIUM: 60,
  HIGH: 40,
  URGENT: 20,
} as const satisfies Record<ErrorSeverity, number>;
